export const trimString = (string: string) => string.replaceAll(' ', '')
